function initializeLoadMoreGrids() { 
    const allLoadMoreBtns = document.querySelectorAll('.tile-grid__pagination > button');

   
    const loadStep = 3;
     
    allLoadMoreBtns.forEach(loadMoreBtn => { 
        const gridTargetId = loadMoreBtn.getAttribute('data-grid-target');

      
        const containerWrapper = document.querySelector(gridTargetId);
        if (!containerWrapper) return;  
 
        const container = containerWrapper.querySelector('.tile-grid__grid');
  
         
        function checkAndToggleButton() { 
            const hiddenItemsCount = container.querySelectorAll('.membership-tile.hide').length;
            if (hiddenItemsCount === 0) {
                loadMoreBtn.parentElement.style.display = 'none';
            }
        }
 
        function loadMore() { 
            const hiddenItems = container.querySelectorAll('.membership-tile.hide');
             
            for (let i = 0; i < loadStep && i < hiddenItems.length; i++) {
                hiddenItems[i].classList.remove('hide');
            }
             
            const remainingHiddenItems = container.querySelectorAll('.membership-tile.hide').length;
             
            if (remainingHiddenItems === 0) {
                loadMoreBtn.parentElement.style.display = 'none';
            }
        }
 
        loadMoreBtn.addEventListener('click', loadMore);
 
        checkAndToggleButton();
    });
}
document.addEventListener('DOMContentLoaded', () => {
    initializeLoadMoreGrids();
});
